import { Controller } from 'stimulus'
import {
  FocusTrap
} from 'shared/assets/javascript/accessibility/focusTrap.js';

export default class extends Controller {
  static targets = ['closeMenuButton','primaryLink', 'subMenu', 'subMenuToggle']
  get menuToggle() {
    return document.querySelector('.js-menu-toggle')
  }

  get skipToContainer() {
    return document.querySelector('.js-skipToContainer')
  }

  get header() {
    return document.querySelector('.header-bar__nav')
  }

  connect() {
    this.state = {
      hidden: true,
      isOpen: false,
      defaultBackground: '',
      backgroundImages: [],
      focusTrapInstance: null
    }

    this.modal = this.element
    this.modalToggle = this.closeMenuButtonTarget
    this.focusTrapInstance = new FocusTrap([this.modalToggle, this.modal])

    this.element.style.display = 'none'
    this.menuToggle.addEventListener('click', this.toggleMenu.bind(this))
    this.closeMenuButtonTarget.addEventListener('click', this.toggleMenu.bind(this))
    this.element.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  preloadMenuImages() {
    this.primaryLinkTargets.forEach((item, index) => {
      this.state.backgroundImages[index] = new Image;
      this.state.backgroundImages[index].src = item.dataset.bg
    })
  }

  swapBackground() {
    let backgroundImage = this.primaryLinkTarget.dataset.bg;

    if (!backgroundImage) {
      backgroundImage = this.state.defaultBackground;
    }

    this.element.style.backgroundImage = `url('${backgroundImage}')`;
  }

  handleKeyUp(event) {
    if ((event.keyCode == 27) && this.state.isOpen) {
      this.menuToggle.click()
    }
  }

  toggleMenu(event) {
    this.preloadMenuImages();
    this.state.isOpen = !this.state.isOpen;
    this.element.setAttribute('aria-hidden', !this.state.hidden)
    if (this.state.isOpen === true) {
      this.focusTrapInstance.set();
      this.header.setAttribute('inert', '');
      this.element.style.display = 'block'
      document.documentElement.classList.add('-hide-page-overflow')
      document.body.classList.add('-hide-page-overflow')
      document.body.classList.add('-is-open-mainmenu')
      setTimeout(()=> {
        this.element.classList.add('-animate')
        this.element.classList.add('is-open')
      }, 10)
      setTimeout(() => {
        this.closeMenuButtonTarget.focus();
      }, 1000);
      this.skipToContainer.style.display = 'none'

    } else {
      this.focusTrapInstance.unset()
      this.header.removeAttribute('inert', '');
      this.menuToggle.focus();
      document.documentElement.classList.remove('-hide-page-overflow')
      document.body.classList.remove('-hide-page-overflow')
      document.body.classList.remove('-is-open-mainmenu')
      setTimeout(()=> {
        this.element.classList.remove('-animate')
        this.element.classList.remove('is-open')
      }, 10)
      setTimeout(()=>{
        this.element.style.display = 'none'
      }, 1000)
      this.skipToContainer.style.display = 'block'
    }
  }

}
